<era-panel>
  <div class="p-2">
    <ml-async-result [operation]="apple$">
      <div empty>
        <p>No device information available.</p>
      </div>

      @if (apple$ | async; as apple) {
        <era-pane>
          <h5 class="small-caps"
              i18n>General</h5>
          <table class="table table-sm table-list mb-4">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th title="The unique device identifier (UDID) of the device."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  UDID
                </th>
                <td>{{ apple.udid }}</td>
              </tr>
              @if (apple | os: { appleTV: '>=6.0', macOS: '10.10 - 10.11' }) {
                <tr>
                  <th scope="row"
                      title="The first entry in this array indicates the current language. Availability: Available in Apple TV software 6.0 and later. Supported in macOS 10.10 and 10.11 but will be removed in a future macOS release."
                      data-toggle="tooltip"
                      data-placement="top"
                      i18n>
                    Languages
                  </th>
                  <td>
                    @if (apple && apple.languages) {
                      <ul>
                        @for (language of apple.languages; track language) {
                          <li>
                            {{ language }}
                          </li>
                        }
                      </ul>
                    }
                  </td>
                </tr>
              }
              @if (apple | os: { appleTV: '>=6.0', macOS: '10.10 - 10.11' }) {
                <tr>
                  <th title="The first entry in this array indicates the current locale. Availability: Available in Apple TV software 6.0 and later. Supported in macOS 10.10 and 10.11 but will be removed in a future macOS release."
                      data-toggle="tooltip"
                      data-placement="top"
                      scope="row"
                      i18n>
                    Locales
                  </th>
                  <td>
                    @if (apple && apple.locales) {
                      <ul>
                        @for (locale of apple.locales; track locale) {
                          <li>
                            {{ locale }}
                          </li>
                        }
                      </ul>
                    }
                  </td>
                </tr>
              }
              @if (apple | os: { appleTV: '>=6.0' }) {
                <tr>
                  <th title="The Apple TV device ID. Available in iOS 7 (Apple TV software 6.0) and later, on Apple TV only."
                      data-toggle="tooltip"
                      data-placement="top"
                      scope="row"
                      i18n>
                    DeviceID
                  </th>
                  <td>{{ apple.deviceID }}</td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.0' }) {
                <tr>
                  <th title="The contents (if any) of a previously set OrganizationInfo setting. Available in iOS 7 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="top"
                      i18n>
                    Organization Info
                  </th>
                  <td></td>
                </tr>
              }
              @if (apple | os: { iOS: '>=8.0' }) {
                <tr>
                  <th title="The date of the last iCloud backup. Availability: Available in iOS 8.0 and later."
                      data-toggle="tooltip"
                      data-placement="top"
                      scope="row"
                      i18n>
                    Last Cloud Backup Date
                  </th>
                  <td>{{ apple.lastCloudBackupDate }}</td>
                </tr>
              }
              @if (apple | os: { iOS: '>=9.0' }) {
                <tr>
                  <th title="If true, device is still waiting for a DeviceConfigured message from MDM to continue through Setup Assistant. Availability: Available in iOS 9 and later and the response is only generated by devices enrolled in MDM via DEP (see Device Enrollment Program)."
                      data-toggle="tooltip"
                      data-placement="top"
                      scope="row"
                      i18n>
                    Awaiting Configuration
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.awaitingConfiguration"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              <!-- <tr *ngIf="apple | os: { macOS: '>=10.11'}">
              <th title="Returns the local admin users (if any) created automatically by Setup Assistant during DEP enrollment via the AccountConfiguration command. Availability: Available in macOS 10.11 and later and the response is only generated by devices enrolled in MDM via DEP (see Device Enrollment Program).
                        Each dictionary in the array contains two keys: a key GUID with a string value of the Global Unique Identifier of a local admin account, and a key shortName with a string value of the short name of the admin account."
                data-toggle="tooltip" data-placement="top" scope="row" i18n>
                Auto Setup Admin Accounts
              </th>
              <td>TODO</td>
            </tr> -->
            </tbody>
          </table>
          @if (apple | os: { iOS: '>=7.0', macOS: '>=10.9' }) {
            <h5 class="small-caps"
                i18n>iTunes Store</h5>
          }
          <table class="table table-sm table-list mb-4">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @if (apple | os: { iOS: '>=7.0', macOS: '>=10.9' }) {
                <tr>
                  <th title="true if the user is currently logged into an active iTunes Store account. Available in iOS 7 and later and in macOS 10.9."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    iTunes Store Account Active
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.iTunesStoreAccountIsActive"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple.iTunesStoreAccountIsActive && (apple | os: { iOS: '>=8.0', macOS: '>=10.10' })) {
                <tr>
                  <th title="Returns a hash of the iTunes Store account currently logged in. This string is identical to the itsIdHash returned by the VPP App Assignment web service. Availability: Available in iOS 8.0 and later and macOS 10.10 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    iTunes Store Account Hash
                  </th>
                  <td>{{ apple.iTunesStoreAccountHash }}</td>
                </tr>
              }
            </tbody>
          </table>
          <h5 class="small-caps"
              i18n>Device</h5>
          <table class="table table-sm table-list mb-4">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th title="The iOS device name or the macOS hostname."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Device Name
                </th>
                <td>{{ apple.deviceName }}</td>
              </tr>
              <tr>
                <th title="The version of iOS the device is running."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  OS Version
                </th>
                <td>{{ apple.osVersion }}</td>
              </tr>
              <tr>
                <th title="The build number (8A260b, for example)."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Build Version
                </th>
                <td>{{ apple.buildVersion }}</td>
              </tr>
              <tr>
                <th title="Name of the device model, e.g., “MacBook Pro.”"
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Model Name
                </th>
                <td>{{ apple.modelName }}</td>
              </tr>
              <tr>
                <th title="The device’s model number (MC319LL, for example)."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Model
                </th>
                <td>{{ apple.model }}</td>
              </tr>
              <tr>
                <th title="The model code for the device (iPhone3,1, for example)."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Product Name
                </th>
                <td>{{ apple.productName }}</td>
              </tr>
              <tr>
                <th title="The device’s serial number."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Serial Number
                </th>
                <td>{{ apple.serialNumber }}</td>
              </tr>
              <tr>
                <th title="Device storage capacity in gigabytes."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Device Capacity
                </th>
                <td>
                  {{
                apple.deviceCapacity && apple.deviceCapacity > 0
                ? (apple.deviceCapacity | number: '1.1-2') + ' GB'
                : 'N/A'
                }}
                </td>
              </tr>
              <tr>
                <th title="Available device storage capacity in gigabytes."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Available Device Capacity
                </th>
                <td>
                  {{
                apple.availableDeviceCapacity && apple.availableDeviceCapacity > 0
                ? (apple.availableDeviceCapacity | number: '1.1-2') + ' GB'
                : 'N/A'
                }}
                </td>
              </tr>
              @if (apple | os: { iOS: '>=5.0' }) {
                <tr>
                  <th title="Percentage expressed as a value between 0.0 and 1.0, or -1.0 if battery level cannot be determined. Availability: Available in iOS 5.0 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Battery Level
                  </th>
                  <td>{{ apple.batteryLevel | percent }}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=4.2.6' })) {
            <h5 class="small-caps"
                i18n>
              Cellular
            </h5>
          }
          @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=4.2.6' })) {
            <table class="table table-sm table-list mb-4">
              <thead>
                <tr>
                  <th colspan="2"
                      scope="col"></th>
                </tr>
              </thead>
              <tbody>
                @if (apple | os: { iOS: '>=4.2.6' }) {
                  <tr>
                    <th title="The type of cellular technology."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Cellular Technology
                    </th>
                    <td>{{ apple.cellularTechnology }}</td>
                  </tr>
                }
                @if (apple.cellularTechnology === 1 || apple.cellularTechnology === 3) {
                  <tr>
                    <th title="The device’s IMEI number. Ignored if the device does not support GSM."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      IMEI
                    </th>
                    <td>{{ apple.imei }}</td>
                  </tr>
                }
                @if (apple.cellularTechnology === 2 || apple.cellularTechnology === 3) {
                  <tr>
                    <th title="The device’s MEID number. Ignored if the device does not support CDMA."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      MEID
                    </th>
                    <td>{{ apple.meid }}</td>
                  </tr>
                }
                @if (apple | os: { iOS: '>=4.2.6' }) {
                  <tr>
                    <th title="The baseband firmware version."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      ModemFirmwareVersion
                    </th>
                    <td>{{ apple.modemFirmwareVersion }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <h5 class="small-caps"
              i18n>Management</h5>
          <table class="table table-sm table-list mb-4">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @if (apple | os: { iOS: '>=6.0', appleTV: '>=6.0' }) {
                <tr>
                  <th title="If true, the device is supervised."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Supervised
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isSupervised"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.0' }) {
                <tr>
                  <th title="If true, the device has a device locator service (such as Find My iPhone) enabled."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Device Locator Service
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isDeviceLocatorServiceEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.0', macOS: '>=10.9' }) {
                <tr>
                  <th title="If true, the device has Activation Lock enabled. Availability: Available in iOS 7 and later and macOS 10.9 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Activation Lock
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isActivationLockEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.0' }) {
                <tr>
                  <th title="If true, Do Not Disturb is in effect. This returns true whenever Do Not Disturb is turned on, even if the device is not currently locked. Availability: Available in iOS 7 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Do Not Disturb In Effect
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isDoNotDisturbInEffect"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { appleTV: '>=6.0' }) {
                <tr>
                  <th title="Device ID"
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">Device ID</th>
                  <td>{{ apple.deviceID }}</td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.0', macOS: '>=10.9' }) {
                <tr>
                  <th title="The Device Identifier string reported to Exchange Active Sync (EAS).
                            Availability: Available in iOS 7 and later and macOS 10.9 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    EAS Device Identifier
                  </th>
                  <td>{{ apple.easDeviceIdentifier }}</td>
                </tr>
              }
              @if (apple | os: { iOS: '>=7.1' }) {
                <tr>
                  <th title="If true, the device has iCloud backup enabled.
                        Availability: Available in iOS 7.1 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Cloud Backup
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isCloudBackupEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { macOS: '>=10.11' }) {
                <tr>
                  <th title="The local host name as reported by Bonjour.
                          Availability: Available in macOS 10.11 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Local HostName
                  </th>
                  <td>{{ apple.localHostName }}</td>
                </tr>
              }
              @if (apple | os: { macOS: '>=10.11' }) {
                <tr>
                  <th title="The host name. Availability: Available in macOS 10.11 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    HostName
                  </th>
                  <td>{{ apple.hostName }}</td>
                </tr>
              }
              @if (apple | os: { macOS: '>=10.12' }) {
                <tr>
                  <th title="Whether System Integrity Protection is enabled on the device. Availability: Available in macOS 10.12 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    System Integrity Protection
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.systemIntegrityProtectionEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { macOS: '>=10.11' }) {
                <tr>
                  <th title="Returns an array of the directory GUIDs (as strings) of the logged-in managed users. This query can be sent only to a device. An additional key, CurrentConsoleManagedUser, is sent in the reply; its string value is the GUID of the managed user active on the console. If no user listed in the ActiveManagedUsers array is currently active on the console, this additional key is omitted from the reply. Availability: Available in macOS 10.11 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Active Managed Users
                  </th>
                  <td>
                    @if (apple && apple.activeManagedUsers) {
                      <ul>
                        @for (user of apple.activeManagedUsers; track user) {
                          <li>
                            {{ user }}
                          </li>
                        }
                      </ul>
                    }
                  </td>
                </tr>
              }
              @if (apple | os: { iOS: '>=9.3' }) {
                <tr>
                  <th title="If true, the device has MDM Lost Mode enabled. Defaults to false. Availability: Available in iOS 9.3 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    MDM Lost Mode
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isMDMLostModeEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple | os: { iOS: '>=9.3' }) {
                <tr>
                  <th title="Returns the maximum number of users that can use this Shared iPad mode device. Availability: Available in iOS 9.3 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Maximum Resident Users
                  </th>
                  <td>{{ apple.maximumResidentUsers }}</td>
                </tr>
              }
            </tbody>
          </table>
          <!-- macOs -->
          @if (apple | os: { macOS: '>=10.11' }) {
            <h5 class="small-caps"
                i18n>OS Update Settings</h5>
          }
          @if (apple | os: { macOS: '>=10.11' }) {
            <table class="table table-sm table-list mb-4">
              <thead>
                <tr>
                  <th colspan="2"
                      scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th title="The URL to the software update catalog currently in use by the client."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Catalog URL
                  </th>
                  <td>{{ apple.osUpdateSettings?.catalogURL }}</td>
                </tr>
                <tr>
                  <th scope="row">Is Default Catalog</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.isDefaultCatalog"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Previous Scan Date</th>
                  <td>{{ apple.osUpdateSettings?.previousScanDate }}</td>
                </tr>
                <tr>
                  <th scope="row">Previous Scan Result</th>
                  <td>{{ apple.osUpdateSettings?.previousScanResult }}</td>
                </tr>
                <tr>
                  <th scope="row">Perform Periodic Check</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.performPeriodicCheck"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Automatic Check</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.automaticCheckEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Background Download</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.backgroundDownloadEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Automatic App Installation</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.automaticAppInstallationEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Automatic OS Installation</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.automaticOSInstallationEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Automatic Security Updates</th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.osUpdateSettings?.automaticSecurityUpdatesEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          }
          <h5 class="small-caps"
              i18n>Network Settings</h5>
          <table class="table table-sm table-list">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @if (apple.cellularTechnology === 1 || apple.cellularTechnology === 3) {
                <tr>
                  <th title="The ICC identifier for the installed SIM card."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    ICCID
                  </th>
                  <td>{{ apple.iccid }}</td>
                </tr>
              }
              <tr>
                <th title="Bluetooth MAC address."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Bluetooth MAC
                </th>
                <td>{{ apple.bluetoothMAC }}</td>
              </tr>
              <tr>
                <th title="Wi-Fi MAC address."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">WiFi MAC</th>
                <td>{{ apple.wiFiMAC }}</td>
              </tr>
              @if (apple | os: { iOS: '>=7.0' }) {
                <tr>
                  <th title="Ethernet MAC addresses. Availability: Available in macOS v10.8 and later, and in iOS 7 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Ethernet MACs
                  </th>
                  <td>
                    @if (apple && apple.ethernetMACs) {
                      <ul>
                        @for (mac of apple.ethernetMACs; track mac) {
                          <li>
                            {{ mac }}
                          </li>
                        }
                      </ul>
                    }
                  </td>
                </tr>
              }
              @if (apple | os: { macOS: '>=10.7' }) {
                <tr>
                  <th title="Ethernet MAC addresses. Availability: Available in macOS v10.8 and later, and in iOS 7 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Ethernet MAC
                  </th>
                  <td>{{ apple.ethernetMACs }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="Name of the current carrier network."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Current Carrier Network
                  </th>
                  <td>{{ apple.currentCarrierNetwork }}</td>
                </tr>
              }
              @if (apple.cellularTechnology === 2 || apple.cellularTechnology === 3) {
                <tr>
                  <th title="Name of the home carrier network. (Note: this query is supported on CDMA in spite of its name.)"
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    SIM Carrier Network
                  </th>
                  <td>{{ apple.simCarrierNetwork }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=5.0' })) {
                <tr>
                  <th title="Name of the home carrier network. (Replaces SIMCarrierNetwork.) Availability: Available in iOS 5.0 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Subscriber Carrier Network
                  </th>
                  <td>{{ apple.subscriberCarrierNetwork }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="Version of the currently-installed carrier settings file."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Carrier Settings Version
                  </th>
                  <td>{{ apple.carrierSettingsVersion }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="Raw phone number without punctuation, including country code."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Phone Number
                  </th>
                  <td>{{ apple.phoneNumber }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=5.0' })) {
                <tr>
                  <th title="The current setting of the Voice Roaming setting. This is only available on certain carriers. Availability: iOS 5.0 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Voice Roaming
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.voiceRoamingEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="The current setting of the Data Roaming setting."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Data Roaming
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.dataRoamingEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=4.2' })) {
                <tr>
                  <th title="Returns whether the device is currently roaming. Availability: Available in iOS 4.2 and later. For older versions of iOS, if the SIMMCC/SMMNC combination does not match the CurrentMCC/CurrentMNC values, the device is probably roaming."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Is Roaming
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.isRoaming"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=7.0' })) {
                <tr>
                  <th title="True if the Personal Hotspot feature is currently turned on. This value is available only with certain carriers. Availability: iOS 7.0 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Personal Hotspot
                  </th>
                  <td>
                    <ml-yes-no-icon [flag]="apple.personalHotspotEnabled"></ml-yes-no-icon>
                  </td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=4.2.6' })) {
                <tr>
                  <th title="Home Mobile Country Code (numeric string). Availability: Available in iOS 4.2.6 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Subscriber MCC
                  </th>
                  <td>{{ apple.subscriberMCC }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0 && (apple | os: { iOS: '>=4.2.6' })) {
                <tr>
                  <th title="Home Mobile Network Code (numeric string). Availability: Available in iOS 4.2.6 and later."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Subscriber MNC
                  </th>
                  <td>{{ apple.subscriberMNC }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="Current Mobile Country Code (numeric string)."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Current MCC
                  </th>
                  <td>{{ apple.currentMCC }}</td>
                </tr>
              }
              @if (apple?.cellularTechnology > 0) {
                <tr>
                  <th title="Current Mobile Network Code (numeric string)."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Current MNC
                  </th>
                  <td>{{ apple.currentMNC }}</td>
                </tr>
              }
            </tbody>
          </table>
        </era-pane>
      }
    </ml-async-result>
  </div>
  <era-panel-footer>
    <div class="btn-toolbar p-1 bg-gray-100 border-top">
      @if (udid$ | async; as udid) {
        <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                                [small]="true"
                                [direction]="'right'"
                                [reverse]="true"
                                class="flex-grow-1 text-end">
          <button type="button"
                  (click)="refresh()"
                  [class]="'btn btn-outline-primary border-0'">
            <fa-icon icon="sync"></fa-icon>
          </button>
        </ml-mdm-command-spinner>
      }
    </div>
  </era-panel-footer>
</era-panel>